import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.concat.js";
import { baseURL } from '@finect/front-utils/baseURL';
export var getCanonicalURL = function getCanonicalURL(path) {
  if (!path) {
    return null;
  }
  if (['https://', 'http://', '//'].some(function (item) {
    return path.startsWith(item);
  })) {
    return path;
  }
  if (['https://', 'http://', '/'].some(function (item) {
    return path.startsWith(item);
  })) {
    return "https://".concat(baseURL).concat(path);
  }
  return null;
};